var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var consolidateLineItems = function (lineItems, hideCanceled) {
    var consolidatedItems = lineItems.reduce(function (acc, item) {
        var _a;
        var existingItem = acc.find(function (accItem) {
            return accItem.skuNumber === item.skuNumber && accItem.omsId === item.omsId;
        });
        if (hideCanceled && item.statusDescription === 'Canceled') {
            return acc;
        }
        if (existingItem) {
            if (existingItem && existingItem.quantity !== undefined) {
                existingItem.quantity += (_a = item.quantity) !== null && _a !== void 0 ? _a : 0;
            }
        }
        else {
            acc.push(__assign({}, item));
        }
        return acc;
    }, []);
    return consolidatedItems;
};
